import React from 'react'
import Slider from 'react-slick'
import { SimpleImage } from '@ten24/slatwall-storefront-react-private/global'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
import { getBrandRoute } from '@ten24/slatwall-storefront-react-private/global'

const BandSlide = ({ imagePath, urlTitle = '', contentHeading, slug, clickable}) => {
  const brand = useSelector(getBrandRoute)
  if(clickable){
    return (
      <div className="brand-slide repeater">
        <div className="card-body">
          <Link to={`/${brand}/${slug}`} style={{height: "150px"}} className="p-2 justify-content-center d-flex align-items-center shadow-sm cursor-pointer">
            {imagePath && <SimpleImage className="w-50" src={!!imagePath ? imagePath : ''} alt={contentHeading} type="brand" /> }
            {!imagePath && <h3>{contentHeading}</h3>}
          </Link>
        </div>
      </div>
    )
  }else{
    return (
      <div className="brand-slide repeater">
        <div className="card-body">
          <div style={{height: "150px"}} className="p-2 justify-content-center d-flex align-items-center shadow-sm">
            {imagePath && <SimpleImage className="w-50" src={!!imagePath ? imagePath : ''} alt={contentHeading} type="brand" /> }
            {!imagePath && <h3>{contentHeading}</h3>}
          </div>
        </div>
      </div>
    )
  }

}

const BrandSlider = props => {
  // const { t } = useTranslation()
  // console.log(props)
  const { relatedBrands = [], contentHeading, clickableBrands } = props

  const settings = {
    dots: false,
    infinite: relatedBrands.length > 3,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    clickableSlides: clickableBrands,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 578,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }
  if (!relatedBrands.length) return null
  return (
    <div className="container ">
      <div className="content-spacer bg-light-blue brand-slider-sec">
      <div className="row">
      <div className="col-12">
        <header className="section-title">
          <h2>{contentHeading}</h2>
        </header>
        <div className="card border-0 bg-transparent">
          <Slider {...settings}>
            {relatedBrands.map((slide, i) => {
              slide.clickable = settings.clickableSlides
              return <BandSlide key={i} {...slide} />
            })}
          </Slider>
        </div>
        {/* <div className="text-center mt-5">
          <Link className="btn btn-primary" to={linkUrl}>
            {linkLabel}
          </Link>
        </div> */}
      </div>
      </div>
      </div>
    </div>
  )
}

export { BrandSlider }